const RLresumeData = {
    cvDate: "2026",

    links: {
        location: "Italy",
        mail: "mailto:kiansegantini@gmail.com",
        behance: "https://behance.net/kiansegantini",
        linkedin: "https://linkedin.com/in/kian-segantini",
    },

    sectionTitles: ["Introduction", "Education", "Languages", "Certifications", "Sports", 
                    "Experience" ],

    introduction: {
        text: "I'm Kian Segantini, a reliable and adaptable young professional based in Italy. I completed high school and have experience working in professional environments, including my current role as a paid pool lifeguard. I'm comfortable taking responsibility, working with the public, following safety procedures, and staying calm under pressure. Alongside my employment experience, I've developed strong digital and communication skills through UX/UI design, technology projects, and independent work. I'm now looking for opportunities where I can contribute, learn quickly, and take on meaningful responsibility.",
    },

    education: {
        cards: [
            {
                start: "2025",
                end: "2026",
                title: "West River Academy",
                subtitle1: "High School Diploma | GPA: 4.0",
                subtitle2: "California, USA",
            },
            {
                start: "2021",
                end: "2024",
                title: "IEXS",
                subtitle1: "High School",
                subtitle2: "Italy",
            },
        ]
    },

    languages: [
        { language: "Italian", level: "Native", percentage: 100 },
        { language: "English", level: "Native", percentage: 95 },
        { language: "Spanish", level: "Intermediate", percentage: 75 },
    ],
    
    certifications: {
        cards: [
            {
                start: "2025",
                end: "2027",
                title: "B.L.S.D.",
                subtitle1: "Basic Life Support Defibrillation",
                subtitle2: "(FIN) Italian Swim Federation",
            },
            {
                start: "2025",
                end: "2030",
                title: "B.A.B. — FULL",
                subtitle1: "Pool Lifeguard",
                subtitle2: "(FIN) Italian Swim Federation",
            },
            {
                start: "2025",
                end: "2028",
                title: "388",
                subtitle1: "Workplace First Aid",
                subtitle2: "(FIN) Italian Swim Federation",
            },
        ]
    },
    
    sports: {
        cards: [
            {
                start: "2016",
                end: "Pres.",
                title: "Swimming",
                subtitle1: "Competitive",
                subtitle2: ""
            },
            {
                start: "2022",
                end: "Pres.",
                title: "Running",
                subtitle1: "Intermediate",
                subtitle2: ""
            },
            {
                start: "2023",
                end: "Pres.",
                title: "Cycling",
                subtitle1: "Intermediate",
                subtitle2: ""
            },
            {
                start: "2022",
                end: "2025\u2009", //The \u2009 (thin Space) is to put everithing to the same gap as Pres.
                title: "Baseball",
                subtitle1: "Competitive (Regional Level)",
                subtitle2: ""
            },
        ]
    },

    experience: {
        cards: [
            {
                start: "2026",
                end: "Pres.",
                title: "RNV Marostica",
                subtitle1: "Paid Contract",
                subtitle2: "Lifeguard responsible for pool safety, emergency response, and maintaining a safe and organized environment.",
            },
            {
                start: "Apr.",
                end: "2025",
                title: "Piscine Di Vicenza",
                subtitle1: "Internship",
                subtitle2: "Completed 42+ hours of internship focused on pool safety, public interaction and emergency management.",
            },
        ]
    },
    // skills: [
    //     { title: "Swimming Proficiency", percentage: 100 },
    //     { title: "CPR & First Aid", percentage: 90 },
    //     { title: "Responsibility", percentage: 100 },
    //     { title: "Situational Awareness", percentage: 90 },
    //     { title: "Teamwork", percentage: 90 },
    //     { title: "Stress Management", percentage: 100 },
    //     { title: "Communication", percentage: 90 },
    //     { title: "Endurance", percentage: 100 },
    //     { title: "Time Management", percentage: 90 },
    //     { title: "Adaptability", percentage: 80 },
    //     { title: "Work Ethic", percentage: 100 },
    //     { title: "Leadership", percentage: 90 },
    // ]
};

export default RLresumeData;